import "./ApiAttribute.css";

export const ApiAttribute = ({ attributeName }) => {
  return <span className="attribute-name-style">{attributeName}</span>;
};
